import type { FunctionComponent } from 'react';

import { Tooltip as FlowbiteTooltip } from 'flowbite-react';

import type { TooltipProps } from './types';

const customTheme = {
  target: 'w-fit',
  animation: 'transition-opacity',
  arrow: {
    base: 'absolute z-10 h-3 w-3 rotate-45',
    style: {
      dark: 'bg-gray-900 dark:bg-gray-700',
      light: 'bg-white',
      auto: 'bg-white dark:bg-gray-700'
    },
    placement: '-4px'
  },
  base: 'absolute z-10 inline-block rounded-md px-3 py-2 text-sm font-medium shadow-sm',
  hidden: 'invisible opacity-0',
  style: {
    dark: 'bg-gray-900 text-white dark:bg-gray-700',
    light: 'border border-gray-200 bg-white text-gray-900',
    auto: 'border border-gray-200 bg-white text-gray-900 dark:border-none dark:bg-gray-700 dark:text-white'
  },
  content: 'relative z-20'
};

export const Tooltip: FunctionComponent<TooltipProps> = ({ content, children, ...props }) => {
  return (
    <FlowbiteTooltip {...props} theme={customTheme} content={content}>
      {children}
    </FlowbiteTooltip>
  );
};
